import React from 'react';
import { Download, X } from 'lucide-react';
import { count } from './format';

interface Props {
  styleCodes: string[];
  onExport: () => void;
  onClear: () => void;
}

// Floating bar for the current row selection.
export const SelectionBar: React.FC<Props> = ({ styleCodes, onExport, onClear }) => {
  const n = styleCodes.length;
  if (n === 0) return null;
  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-14 z-40 flex justify-center px-4">
      <div className="pointer-events-auto flex items-center gap-1 rounded-full bg-[color:var(--oa-pill-bg)] py-1 pl-4 pr-1 text-[color:var(--oa-pill-text)] shadow-[0_12px_40px_-12px_rgba(11,15,25,0.6)] ring-1 ring-white/10">
        <span className="mr-2 text-[13px] tabular-nums">
          <b className="text-[color:var(--oa-accent-2)]">{count(n)}</b> {n === 1 ? 'style' : 'styles'}
        </span>
        <span className="mx-1 h-5 w-px bg-[color:color-mix(in_oklab,var(--oa-pill-text)_15%,transparent)]" />
        <button type="button" onClick={onExport} className="inline-flex h-8 items-center gap-1.5 rounded-full px-3 text-[13px] font-medium text-[color:color-mix(in_oklab,var(--oa-pill-text)_90%,transparent)] transition-colors hover:bg-[color:color-mix(in_oklab,var(--oa-pill-text)_10%,transparent)] hover:text-[color:var(--oa-pill-text)]">
          <Download className="h-4 w-4" />
          Export selection
        </button>
        <button type="button" onClick={onClear} aria-label="Clear selection" className="ml-1 rounded-full p-1.5 text-[color:color-mix(in_oklab,var(--oa-pill-text)_70%,transparent)] hover:bg-[color:color-mix(in_oklab,var(--oa-pill-text)_10%,transparent)] hover:text-[color:var(--oa-pill-text)]">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};
